import React from "react";
import { Link } from "react-router-dom";
import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSchool, faInfo } from "@fortawesome/free-solid-svg-icons";

const CcpDistrictLinks = () => {
  const [openSettings, setOpenSettings] = React.useState(false);

  const handleSettingsToggle = () => {
    setOpenSettings(!openSettings);
  };
  return (
    <>
      <ListItem sx={{ mt: 2 }}>
        <Link to="/Dashboard">
          <ListItemIcon>
            <FontAwesomeIcon
              icon={faSchool}
              style={{
                color: "teal",
                fontSize: "2rem",
              }}
            />
          </ListItemIcon>
        </Link>
        <Link to="/Dashboard">
          <ListItemText primary="My Schools" />
        </Link>
      </ListItem>

      <ListItem sx={{ mt: 2 }}>
        <Link to="/CcpSchoolHelp">
          <ListItemIcon>
            <FontAwesomeIcon
              icon={faInfo}
              style={{
                color: "teal",
                fontSize: "2rem",
              }}
            />
          </ListItemIcon>
        </Link>
        <Link to="/CcpSchoolHelp">
          <ListItemText primary="Help & FAQ's" />
        </Link>
      </ListItem>
    </>
  );
};

export default CcpDistrictLinks;
